import React, { Component } from 'react';

class AboutCommit extends Component {
   render() {
      return (
        <React.Fragment>
            <p id="title">EMS Commitment</p>
            <ul>
                <li>
                    To put our ultimate efforts and expertise to deliver the best service to our clients
                </li>
                <li>
                    To deliver the best advices in regard to managing their facilities and to be completely honest and transparent
                </li>
                <li>
                    To provide our team members with the training and tools needed to deliver the best level of service
                </li>
            </ul>
        </React.Fragment>
      );
   }
}

export default AboutCommit;